const emptyBanners = { fopBanner: null, customFopSection: null };
const getFopBanners = (scribePageName, scribeContent) => {
  const scribePage = scribeContent[scribePageName];
  const fopBanner = scribePage && scribePage.fopBanner;
  const customFopSection = scribePage && scribePage.customFopSection;

  if (!fopBanner && !customFopSection) return null;

  return {
    parentTitle: scribePage.docTitle,
    fopBanner,
    customFopSection,
  };
};

export function getFopBannersFromScribeContent(scribeContent) {
  if (!scribeContent) {
    return emptyBanners;
  }

  const scribePagesNames = ['eventLandingPage', 'landingPage', 'supplierSearchPage'];

  for (const scribePageName of scribePagesNames) {
    const fopBanners = getFopBanners(scribePageName, scribeContent);

    if (fopBanners) {
      return fopBanners;
    }
  }

  return emptyBanners;
}
